import { Box, Typography, Button } from "@mui/material";
import { useTranslation } from "react-i18next";

type ErrorBoundaryFallbackProps = {
  onReload: () => void;
};

export function ErrorBoundaryFallback({ onReload }: ErrorBoundaryFallbackProps) {
  const { t } = useTranslation();

  const translations = {
    title: t("errorBoundary.title"),
    message: t("errorBoundary.message"),
    reload: t("errorBoundary.reload"),
  };

  return (
    <Box sx={{ p: 4, textAlign: "center" }}>
      <Typography variant="h5" gutterBottom>
        {translations.title}
      </Typography>
      <Typography sx={{ mb: 2 }}>{translations.message}</Typography>
      <Button variant="contained" onClick={onReload}>
        {translations.reload}
      </Button>
    </Box>
  );
}
